module.exports = __webpack_public_path__ + "img/1.9dc027b8.jpg";